<template>
  <v-container fluid>
    <h1>Cargue las bobinas con sus secuencias</h1>
    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-col cols="12" style="margin-top: 2%">
        <v-card color="#1F7087">
          <v-card-title class="text-h5">
            Cargar secuencias de Bobinas
          </v-card-title>
          <v-data-table
            :search="buscarBobina"
            :headers="cabecerasBobinas"
            :items="tablaMaterialesBobinas"
            sort-by="Material"
            class="elevation-1"
            no-results-text="No se encontraron resultados"
            no-data-text="No ha cargado Ningun Dato"
            :footer-props="$store.state.traduccionTabla"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Bobinas</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field
                  v-model="buscarBobina"
                  label="Buscar Bobina"
                  class="mt-5"
                ></v-text-field>
                <v-spacer></v-spacer>

                <v-dialog v-model="modalEliminarModel" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Desea quitar la bobina de la lista?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="eliminarBobinaConfirmar"
                        >Eliminar Bobina</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:[`item.idBobinaComercial`]="props">
              <template
                v-if="
                  props.item.idBobinaComercial == null ||
                  props.item.idBobinaComercial == ''
                "
              >
                <v-text-field
                  v-model="props.item.idBobinaComercialInput"
                  :label="`ID Bobina`"
                  :rules="[validarFormatoBobina]"
                  @input="corregirInput(props)"
                  @keydown="protegerPrefijo($event)"
                  @cut.prevent
                  @paste="protegerPegado($event, props)"
                ></v-text-field>
              </template>
              <template v-else>
                {{ props.item.idBobinaComercial }}
              </template>
            </template>

            <template v-slot:[`item.secInicio`]="props">
              <v-text-field
                v-model="props.item.secInicio"
                label="Secuencia Inicio"
                type="number"
              ></v-text-field>
            </template>
            <template v-slot:[`item.secFin`]="props">
              <v-text-field
                v-model="props.item.secFin"
                label="Secuencia Fin"
                type="number"
              ></v-text-field>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom mg="1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    small
                    fab
                    dark
                    @click="eliminarBobina(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Bobina</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-form>
    <v-btn class="mt-5" color="primary" @click="guardarBobinas()">
      Guardar Bobinas
    </v-btn>
    <dialogMensaje ref="dialogMensaje" />
  </v-container>
</template>
<script>
//import insertMaterial from "@/modulos/Materiales/componentes/modalBobinas.vue";
import axios from "axios";
import dialogMensaje from "@/components/modalMensaje.vue";
export default {
  components: { dialogMensaje },
  data: () => ({
    buscarBobina: "",
    modalEliminarModel: false,
    idOT: "",
    tablaMaterialesBobinas: [],
    listaBobinas: [],
    cabecerasBobinas: [
      {
        text: "ID Cable",
        value: "idMaterialCable",
        class: "black white--text",
      },
      {
        text: "Cable",
        value: "descripcionCable",
        class: "black white--text",
      },
      {
        text: "ID Vale",
        value: "idVale",
        class: "black white--text",
      },
      {
        text: "Bobina",
        value: "idBobinaComercial",
        class: "black white--text",
      },
      {
        text: "Secuencia Inicio",
        value: "secInicio",
        class: "black white--text",
      },
      {
        text: "Secuencia Fin",
        value: "secFin",
        class: "black white--text",
      },
      {
        text: "Cantidad",
        value: "cantidad",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        class: "black white--text",
      },
    ],
  }),

  async mounted() {
    console.log("Ingreso en el modal bobinas");
    this.listaBobinas = this.$route.params.datos;
    this.idOT = this.$route.params.idOT;
    console.log("Los datos de las bobinas son: ");
    console.log(this.listaBobinas);
    this.$refs.dialogMensaje.abrirMensajeDialog(
      "Hay bobinas sin secuencias definidas, por favor cargue las secuencias correspondientes para continuar",
      1,
      "red",
      "Confirmacion"
    );
    await this.cargarBobinas();
    //this.tablaMaterialesBobinas = bobinas;
  },
  methods: {
    eliminarBobinaConfirmar() {
      console.log("La tabla materiales");
      console.log(this.tablaMaterialesBobinas[this.editedIndex]);
      console.log("La tabla materiales bobinas");
      console.log(this.tablaMaterialesBobinas);

      this.tablaMaterialesBobinas.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    eliminarBobina(item) {
      console.log("Presiono Eliminar BObina");
      this.editedIndex = this.tablaMaterialesBobinas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.modalEliminarModel = true;
    },

    validarFormatoBobina(valor) {
      console.log("El valor es:");
      console.log(valor);

      const prefijo = "";
      const regex = new RegExp(`^${prefijo}[A-Za-z]\\d{4}$`);

      return regex.test(valor) ? true : `Debe comenzar con 1 letra y 4 dígitos`;
    },

    eliminarMaterialBobinaConfirmar() {
      this.tablaMaterialesBobinas.splice(this.editedIndex, 1);
      this.closeDelete();
      //console.log("Esto hay en la tabla: ");
      //console.log(this.tablaMateriales);
    },

    closeDelete() {
      this.modalEliminarModel = false;
    },

    // corregirInput(props) {
    //   const prefijo = this.$store.getters.usuario.idDistrito + "_";
    //   let valor = props.item.idBobinaComercialInput;

    //   // Asegurar que siempre empiece con el prefijo
    //   if (!valor.startsWith(prefijo)) {
    //     valor = prefijo + valor.slice(prefijo.length);
    //   }

    //   // Extraer caracteres después del prefijo
    //   let resto = valor.slice(prefijo.length);

    //   console.log("El resto de la bobina es");
    //   console.log(resto);

    //   let nuevoValor = "";

    //   let bandera = false;
    //   // Validar el 5º carácter (1º después del prefijo): letra
    //   if (resto.length == 1) {
    //     const letra = resto.charAt(0);
    //     console.log("La longitud es 1");
    //     console.log(letra);
    //     if (/[a-zA-Z]/.test(letra)) {
    //       bandera = false;
    //       nuevoValor += letra;
    //     } else {
    //       bandera = true;
    //     }
    //   }

    //   // Validar 4 dígitos siguientes (posiciones 6–9)
    //   // for (let i = 1; i < 5; i++) {
    //   //   const char = resto.charAt(i);
    //   //   if (/[0-9]/.test(char)) {
    //   //     bandera = false;
    //   //     nuevoValor += char;
    //   //   } else {
    //   //     bandera = true;
    //   //   }
    //   // }

    //   if (resto.length > 1) {
    //     for (let i = 1; i <= 4; i++) {
    //       const char = resto.charAt(i);
    //       if (/[0-9]/.test(char)) {
    //         bandera = false;
    //         nuevoValor += char;
    //       } else {
    //         bandera = true;
    //         break;
    //       }
    //     }
    //   }

    //   console.log("El valor de la bandera es:");
    //   console.log(bandera);

    //   if (bandera) {
    //     props.item.idBobinaComercialInput = valor.slice(0, -1);
    //   } else {
    //     props.item.idBobinaComercialInput = prefijo + nuevoValor;
    //   }
    // },

    corregirInput(props) {
      const prefijo = "";
      let valor = props.item.idBobinaComercialInput;

      // Asegurar que empiece con el prefijo
      if (!valor.startsWith(prefijo)) {
        valor = prefijo + valor.slice(prefijo.length);
      }

      // Extraer parte después del prefijo
      let resto = valor.slice(prefijo.length);
      let nuevoValor = "";
      let esValido = true;

      // Validar 1ª letra
      if (resto.length >= 1) {
        const letra = resto.charAt(0);
        if (/[a-zA-Z]/.test(letra)) {
          nuevoValor += letra;
        } else {
          esValido = false;
        }
      }

      // Validar siguientes 4 dígitos
      for (let i = 1; i < resto.length && i <= 4; i++) {
        const char = resto.charAt(i);
        if (/[0-9]/.test(char)) {
          nuevoValor += char;
        } else {
          esValido = false;
          break;
        }
      }

      if (!esValido || resto.length > 5) {
        // Borrar último carácter si no es válido o excede longitud
        props.item.idBobinaComercialInput = valor.slice(0, -1);
      } else {
        // Asignar valor reconstruido con prefijo
        props.item.idBobinaComercialInput = prefijo + nuevoValor;
      }
    },

    protegerPrefijo(event) {
      const prefijo = "";
      //const valor = props.item.idBobinaComercialInput;
      const pos = event.target.selectionStart;

      //console.log(valor);

      // No permitir borrar/cortar antes o dentro del prefijo
      if (
        (event.key === "Backspace" && pos <= prefijo.length) ||
        (event.key === "Delete" && pos < prefijo.length) ||
        (event.key.length === 1 && pos < prefijo.length) // letras, números, etc.
      ) {
        event.preventDefault();
      }
    },

    protegerPegado(event, props) {
      const prefijo = "";
      const textoPegado = (event.clipboardData || window.clipboardData).getData(
        "text"
      );

      // Solo permito pegar si se mantiene el prefijo
      if (!textoPegado.startsWith(prefijo)) {
        event.preventDefault();
      } else {
        // En caso que el texto pegado sea válido, lo seteo forzadamente
        props.item.idBobinaComercialInput = textoPegado;
      }
    },

    cargarBobinas() {
      // Mapear los datos de bobinas a la estructura de la tabla
      // this.listaBobinas = this.listaBobinas.filter(
      //   (bobina) => bobina.idBobina == 0
      // );

      console.log("La bobinas despues de limpiar son:");
      console.log(this.listaBobinas);

      this.tablaMaterialesBobinas = this.listaBobinas.map((bobina) => ({
        idBobinaC: bobina.idBobinaC,
        idMaterialCable: bobina.idMaterialCable,
        descripcionCable: bobina.descripcionCable,
        idBobinaComercial: bobina.idBobinaComercial,
        cantidad: bobina.cantidadMetros,
        idVale: bobina.idVale,
        secInicio: 0, // Si tienes este dato, cámbialo
        secFin: 0, // Si tienes este dato, cámbialo
      }));

      this.tablaMaterialesBobinas.forEach((item) => {
        if (!item.idBobinaComercial) {
          item.idBobinaComercialInput = "";
        }
      });

      console.log("Las bobinas son:");
      console.log(this.tablaMaterialesBobinas);
    },

    async guardarBobinas() {
      console.log("Ingresos a cargar los materiales de cajon cuadrilla");
      console.log(this.tablaMaterialesBobinas);
      var bobinaIncorrecta = 0;

      this.tablaMaterialesBobinas.forEach((bobina) => {
        if (bobina.idBobinaComercial == "") {
          const resultado = this.validarFormatoBobina(
            bobina.idBobinaComercialInput
          );
          if (
            typeof resultado === "string" &&
            resultado.includes("Debe comenzar con")
          ) {
            bobinaIncorrecta = 2;
            return;
          }
        }
      });

      if (bobinaIncorrecta == 2) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Alguna/s de las bobinas no respetan el formato",
          1,
          "red",
          "Aviso"
        );
        return;
      }

      this.tablaMaterialesBobinas.forEach((bobina) => {
        if (
          bobina.secFin - bobina.secInicio != bobina.cantidad &&
          bobina.secInicio - bobina.secFin != bobina.cantidad
        ) {
          console.log(
            "El rango de las secuencias no coinciden con la cantidad"
          );
          bobinaIncorrecta = 1;
          return;
        }
      });

      // this.tablaMaterialesBobinas.forEach((bobina) => {
      //   if (bobina.secInicio - bobina.secFin != bobina.cantidad) {
      //     console.log(
      //       "El rango de las secuencias no coinciden con la cantidad"
      //     );
      //     bobinaIncorrecta = 1;
      //     return;
      //   }
      // });

      if (bobinaIncorrecta == 1) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "El rango de las secuencias no coinciden con la cantidad",
          1,
          "red",
          "Aviso"
        );
        return;
      }

      this.url = this.$store.state.urlBase + "Bobina/ingresarBobinas";

      let bobinas = this.tablaMaterialesBobinas.map((item) => ({
        idBobinaOriginal: item.idBobinaC,
        idBobinaC:
          item.idBobinaComercialInput !== undefined &&
          item.idBobinaComercialInput !== null &&
          item.idBobinaComercialInput !== ""
            ? item.idBobinaComercialInput
            : item.idBobinaComercial,
        idMaterialCable: item.idMaterialCable,
        secInicio: item.secInicio,
        secFin: item.secFin,
        idOT: this.idOT,
        idVale: item.idVale,
      }));

      let datos = {
        bobinas: bobinas,
      };

      console.log("Los datos son");
      console.log(datos);

      try {
        const respuesta = await axios.post(this.url, datos, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (respuesta.status === 200) {
          // console.log("La lista de Materiales del cajon de la cuadrilla es:");
          // console.log(respuesta.data);
          this.listaMateriales = respuesta.data;
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Operacion Exitosa",
            2,
            "green",
            "Confirmacion"
          );
          this.$router.push({
            name: "Cajones",
            params: {
              datos: this.listaBobinas,
              idOT: this.idOTTitulo,
            },
          });
        } else {
          console.log("Error");
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },
  },
};
</script>
